import { Converter } from '../types/converter';

export const volumeConverter: Converter = {
  id: 'volume',
  name: 'Volume Converter',
  icon: 'Box',
  categories: ['common', 'engineering'],
  units: [
    // Base SI unit
    { name: 'Cubic Meter', symbol: 'm³', factor: 1 },
    
    // SI derived
    { name: 'Cubic Kilometer', symbol: 'km³', factor: 1e9 },
    { name: 'Cubic Centimeter', symbol: 'cm³', factor: 1e-6 },
    { name: 'Cubic Millimeter', symbol: 'mm³', factor: 1e-9 },
    { name: 'Cubic Decimeter', symbol: 'dm³', factor: 0.001 },
    
    // Liters and derivatives
    { name: 'Liter', symbol: 'L', factor: 0.001 },
    { name: 'Milliliter', symbol: 'mL', factor: 1e-6 },
    { name: 'Exaliter', symbol: 'EL', factor: 1e15 },
    { name: 'Petaliter', symbol: 'PL', factor: 1e12 },
    { name: 'Teraliter', symbol: 'TL', factor: 1e9 },
    { name: 'Gigaliter', symbol: 'GL', factor: 1e6 },
    { name: 'Megaliter', symbol: 'ML', factor: 1e3 },
    { name: 'Kiloliter', symbol: 'kL', factor: 1 },
    { name: 'Hectoliter', symbol: 'hL', factor: 0.1 },
    { name: 'Dekaliter', symbol: 'daL', factor: 0.01 },
    { name: 'Deciliter', symbol: 'dL', factor: 0.0001 },
    { name: 'Centiliter', symbol: 'cL', factor: 0.00001 },
    { name: 'Microliter', symbol: 'µL', factor: 1e-9 },
    { name: 'Nanoliter', symbol: 'nL', factor: 1e-12 },
    { name: 'Picoliter', symbol: 'pL', factor: 1e-15 },
    { name: 'Femtoliter', symbol: 'fL', factor: 1e-18 },
    { name: 'Attoliter', symbol: 'aL', factor: 1e-21 },
    
    // US units
    { name: 'Gallon (US)', symbol: 'gal (US)', factor: 0.003785411784 },
    { name: 'Quart (US)', symbol: 'qt (US)', factor: 0.000946352946 },
    { name: 'Pint (US)', symbol: 'pt (US)', factor: 0.000473176473 },
    { name: 'Cup (US)', symbol: 'cup (US)', factor: 0.0002365882365 },
    { name: 'Tablespoon (US)', symbol: 'tbsp (US)', factor: 1.4787e-5 },
    { name: 'Teaspoon (US)', symbol: 'tsp (US)', factor: 4.9289e-6 },
    
    // Imperial/UK units
    { name: 'Gallon (UK)', symbol: 'gal (UK)', factor: 0.00454609 },
    { name: 'Quart (UK)', symbol: 'qt (UK)', factor: 0.0011365225 },
    { name: 'Pint (UK)', symbol: 'pt (UK)', factor: 0.00056826125 },
    { name: 'Cup (UK)', symbol: 'cup (UK)', factor: 0.000284130625 },
    { name: 'Fluid Ounce (US)', symbol: 'fl oz (US)', factor: 2.95735295625e-5 },
    { name: 'Fluid Ounce (UK)', symbol: 'fl oz (UK)', factor: 2.84130625e-5 },
    
    // Cubic imperial
    { name: 'Cubic Mile', symbol: 'mi³', factor: 4.168181825e9 },
    { name: 'Cubic Yard', symbol: 'yd³', factor: 0.764554857984 },
    { name: 'Cubic Foot', symbol: 'ft³', factor: 0.028316846592 },
    { name: 'Cubic Inch', symbol: 'in³', factor: 1.6387064e-5 },
    
    // Additional volume units
    { name: 'CC', symbol: 'cc', factor: 1e-6 },
    { name: 'Drop', symbol: 'drop', factor: 5e-8 },
    { name: 'Barrel (Oil)', symbol: 'bbl (oil)', factor: 0.158987294928 },
    { name: 'Barrel (US)', symbol: 'bbl (US)', factor: 0.119240471196 },
    { name: 'Barrel (UK)', symbol: 'bbl (UK)', factor: 0.16365924 },
    
    // Metric cooking
    { name: 'Cup (Metric)', symbol: 'cup (metric)', factor: 0.00025 },
    { name: 'Tablespoon (Metric)', symbol: 'tbsp (metric)', factor: 1.5e-5 },
    { name: 'Tablespoon (UK)', symbol: 'tbsp (UK)', factor: 1.77581640625e-5 },
    { name: 'Dessertspoon (US)', symbol: 'dstspn (US)', factor: 9.8578e-6 },
    { name: 'Dessertspoon (UK)', symbol: 'dstspn (UK)', factor: 1.18388e-5 },
    { name: 'Teaspoon (Metric)', symbol: 'tsp (metric)', factor: 5e-6 },
    { name: 'Teaspoon (UK)', symbol: 'tsp (UK)', factor: 5.91938802083e-6 },
    
    // Historical/Special units
    { name: 'Gill (US)', symbol: 'gi (US)', factor: 0.00011829411825 },
    { name: 'Gill (UK)', symbol: 'gi (UK)', factor: 0.0001420653125 },
    { name: 'Minim (US)', symbol: 'min (US)', factor: 6.161152e-8 },
    { name: 'Minim (UK)', symbol: 'min (UK)', factor: 5.91938802083e-8 },
    { name: 'Ton Register', symbol: 'ton reg', factor: 2.8316846592 },
    { name: 'CCF', symbol: 'CCF', factor: 2.8316846592 },
    { name: 'Hundred Cubic Foot', symbol: 'hundred ft³', factor: 2.8316846592 },
    { name: 'Acre-Foot', symbol: 'ac*ft', factor: 1233.48183754752 },
    { name: 'Acre-Foot (US Survey)', symbol: 'ac*ft (US)', factor: 1233.4892384681 },
    { name: 'Acre-Inch', symbol: 'ac*in', factor: 102.790153129293 },
    { name: 'Stere', symbol: 'st', factor: 1 },
    { name: 'Dekastere', symbol: 'dast', factor: 10 },
    { name: 'Decistere', symbol: 'dst', factor: 0.1 },
    { name: 'Cord', symbol: 'cd', factor: 3.624556363776 },
    { name: 'Tun', symbol: 'tun', factor: 0.953923769568 },
    { name: 'Hogshead', symbol: 'hogshead', factor: 0.238480942392 },
    { name: 'Board Foot', symbol: 'bf', factor: 0.002359737216 },
    { name: 'Dram', symbol: 'dr', factor: 3.6966911953125e-6 },
    
    // Biblical units
    { name: 'Cor (Biblical)', symbol: 'cor', factor: 0.22 },
    { name: 'Homer (Biblical)', symbol: 'homer', factor: 0.22 },
    { name: 'Bath (Biblical)', symbol: 'bath', factor: 0.022 },
    { name: 'Hin (Biblical)', symbol: 'hin', factor: 0.0037 },
    { name: 'Cab (Biblical)', symbol: 'cab', factor: 0.001375 },
    { name: 'Log (Biblical)', symbol: 'log', factor: 0.00031 },
    
    // Other
    { name: 'Taza (Spanish)', symbol: 'taza', factor: 0.00024 },
    { name: "Earth's Volume", symbol: 'V⊕', factor: 1.08321e12 }
  ]
};